define(function(require) {
    'use strict';

    var $ = require('j');
    require('widgets/paging.widget');

    return $.widget('paging', 'paging', {

        _setActivePager: function(index) {
            this.super._setActivePager.apply(this, arguments);

            var hasFnGamesClass = this.$el.hasClass('fn-games');
            var hasFnGamesEl = this.$el.find('.fn-games')[0];

            var shouldManageArrows = hasFnGamesClass || hasFnGamesEl;
            if (shouldManageArrows) {
                var isFirstPage = index === 0;
                var isLastPage = index === this.options.lengthOfPages - 1;

                this.$('.fn-goto-previous').toggleClass('hidden', isFirstPage);
                this.$('.fn-goto-next').toggleClass('hidden', isLastPage);
            }
        }
    });
});
